const TOGGLE_SELECTED_EVENT = 'TOGGLE_SELECTED_EVENT';

export default {
  TOGGLE_SELECTED_EVENT
};
